const grade_4= {
    label: "Grade 4",
    subjects: {
      "applied_design_4": {
    "label": "Applied Design (Grade 4)",
    "topics": [
      { "value": "Understanding_Context", "label": "Understanding Context" },
      { "value": "defining", "label": "Defining" },
      { "value": "ideating", "label": "Ideating" },
      { "value": "prototyping", "label": "Prototyping" },
      { "value": "testing", "label": "Testing" },
      { "value": "making", "label": "Making" },
      { "value": "sharing", "label": "Sharing" },
      { "value": "applied_skills", "label": "Applied Skills" },
      { "value": "applied_technologies", "label": "Applied Technologies" }
    ],
    "competencies": {
      "core": [
      { "value": "Understanding_Context", "label": "Understanding Context" },
      { "value": "defining", "label": "Defining" },
      { "value": "ideating", "label": "Ideating" },
      { "value": "prototyping", "label": "Prototyping" },
      { "value": "testing", "label": "Testing" },
      { "value": "making", "label": "Making" },
      { "value": "sharing", "label": "Sharing" },
      { "value": "applied_skills", "label": "Applied Skills" },
      { "value": "applied_technologies", "label": "Applied Technologies" }
      ],
      "sub": {
        "applied_design": [
          /* -------------------- Defining -------------------- */
          {
            "value": "gather_information",
            "label": "Gather information about or from potential users"
          },
          {
            "value": "choose_design_opportunity",
            "label": "Choose a design opportunity"
          },
          {
            "value": "identify_key_features",
            "label": "Identify key features or user requirements"
          },
          {
            "value": "identify_main_objective",
            "label": "Identify the main objective for the design and any constraints"
          },

          /* -------------------- Ideating -------------------- */
          {
            "value": "generate_potential_ideas",
            "label": "Generate potential ideas and add to others’ ideas"
          },
          {
            "value": "screen_ideas",
            "label": "Screen ideas against the objective and constraints"
          },
          {
            "value": "choose_idea_to_pursue",
            "label": "Choose an idea to pursue"
          },

          /* -------------------- Prototyping -------------------- */
          {
            "value": "outline_general_plan",
            "label": "Outline a general plan, identifying tools and materials"
          },
          {
            "value": "construct_first_version",
            "label": "Construct a first version of the product, making changes to tools, materials, and procedures as needed"
          },
          {
            "value": "record_iterations",
            "label": "Record iterations of prototyping"
          },

          /* -------------------- Testing -------------------- */
          {
            "value": "test_product",
            "label": "Test the product"
          },
          {
            "value": "gather_peer_feedback",
            "label": "Gather peer feedback and inspiration"
          },
          {
            "value": "make_changes_and_test_again",
            "label": "Make changes and test again, repeating until satisfied with the product"
          },

          /* -------------------- Making -------------------- */
          {
            "value": "construct_final_product",
            "label": "Construct the final product, incorporating planned changes"
          },

          /* -------------------- Sharing -------------------- */
          {
            "value": "decide_sharing",
            "label": "Decide on how and with whom to share their product"
          },
          {
            "value": "demonstrate_product_and_process",
            "label": "Demonstrate their product and describe their process"
          },
          {
            "value": "determine_product_success",
            "label": "Determine whether their product meets the objective and contributes to the individual, family, community, and/or environment"
          },
          {
            "value": "reflect_on_design_thinking",
            "label": "Reflect on their design thinking and processes, and their ability to work effectively both as individuals and collaboratively in a group, including their ability to share and maintain a co-operative workspace"
          },
          {
            "value": "identify_new_design_issues",
            "label": "Identify new design issues"
          }
        ],

        /* -------------------- Applied Skills -------------------- */
        "applied_skills": [
          {
            "value": "safe_use_tools_awareness",
            "label": "Use materials, tools, and technologies in a safe manner, and with awareness of the safety of others, in both physical and digital environments"
          },
          {
            "value": "identify_and_develop_skills",
            "label": "Identify the skills required for a task and develop those skills as needed"
          }
        ],

        /* -------------------- Applied Technologies -------------------- */
        "applied_technologies": [
          {
            "value": "use_familiar_tools",
            "label": "Use familiar tools and technologies to extend their capabilities when completing a task"
          },
          {
            "value": "choose_appropriate_technologies",
            "label": "Choose appropriate technologies to use for specific tasks"
          },
          {
            "value": "willing_to_learn_new_technologies",
            "label": "Demonstrate a willingness to learn new technologies as needed"
          }
        ]
      }
    }
  }

,    
  "arts_4": {
    "label": "Arts Education (Grade 4)",
   topics: [
        { value: "Expanding and Creating", label: "Expanding and Creating" },
        { value: "reasoning_reflecting", label: "Reasoning and Reflecting" },
        { value: "communicating_documenting", label: "Communicating and Documenting" },
        // { value: "connecting_expanding", label: "Connecting and Expanding" }
      ],
      competencies: {
        core: [
          { value: "Exploring", label: "Expanding and Creating" },
          { value: "Reasoning", label: "Reasoning and Reflecting" },
          { value: "Communicating", label: "Communicating and Documenting" },
          // { value: "Connecting", label: "Connecting and Expanding" }
        ],

      "sub": {
        "exploring_creating": [
          {
            "value": "choose_elements_processes_grade4",
            "label": "Choose artistic elements, processes, materials, movements, technologies, tools, techniques, and environments using combinations and selections for specific purposes in art making"
          },
          {
            "value": "create_artistic_works_grade4",
            "label": "Create artistic works collaboratively and individually using ideas inspired by imagination, inquiry, experimentation, and purposeful play"
          },
          {
            "value": "explore_identity_place_culture_grade4",
            "label": "Explore identity, place, culture, and belonging through arts experiences"
          },
          {
            "value": "explore_relationships_cultures_societies_arts",
            "label": "Explore relationships among cultures, societies, and the arts"
          }
        ],

        "reasoning_reflecting": [
          {
            "value": "observe_listen_predict_grade4",
            "label": "Observe, listen, describe, inquire, and predict how artists use processes, materials, movements, technologies, tools, techniques, and environments to create and communicate"
          },
          {
            "value": "develop_refine_ideas_processes_grade4",
            "label": "Develop and refine ideas, processes, and technical skills in a variety of art forms to improve artistic creations"
          },
          {
            "value": "reflect_creative_process_grade4",
            "label": "Reflect on creative processes and make connections to other experiences"
          },
          {
            "value": "connect_skills_other_learning_grade4",
            "label": "Connect knowledge and skills from other areas of learning in planning, creating, interpreting, and analyzing works of art"
          }
        ],

        "communicating_documenting": [
          {
            "value": "interpret_symbolism_grade4",
            "label": "Interpret and communicate ideas using symbolism to express meaning through the arts"
          },
          {
            "value": "express_feelings_ideas_grade4",
            "label": "Express feelings, ideas, and experiences creatively"
          },
          {
            "value": "describe_respond_artists_intent",
            "label": "Describe and respond to works of art and explore artists’ intent"
          }
        ],

        "connecting_expanding": [
          {
            "value": "experience_document_present_grade4",
            "label": "Experience, document, and present creative works in various ways"
          },
          {
            "value": "demonstrate_sophisticated_application_grade4",
            "label": "Demonstrate increasingly sophisticated application and/or engagement of curricular content"
          }
        ]
      }
    }
  }
,

 career_education_4: {
        label: 'Career Education (Grade 4)',
        topics: [],
        competencies: {
          core: [
            { value: 'examine', label: 'Examine' },
            { value: 'interact', label: 'Interact' },
            { value: 'experience', label: 'Experience' },
            { value: 'initiate', label: 'Initiate' },
            { value: 'share', label: 'Share' }
          ],
          sub: {
            examine: [
              { value: 'identify_and_appreciate_personal_attributes', label: 'Identify and appreciate their personal attributes, skills, interests, and accomplishments and their growth over time' },
              { value: 'demonstrate_respect_for_differences', label: 'Demonstrate respect for differences in the classroom' },
              { value: 'appreciate_the_influence_of_peer_relationships', label: 'Appreciate the influence of peer relationships, family, and community on personal choices and goals' }
            ],
            interact: [
              { value: 'use_innovative_thinking', label: 'Use innovative thinking when solving problems' },
              { value: 'make_connections_between_effective_work_habits_and_success', label: 'Make connections between effective work habits and success' },
              { value: 'recognize_the_need_for_others_who_can_support', label: 'Recognize the need for others who can support their learning and personal growth' }
            ],
            experience: [
              { value: 'set_realistic_short_and_longer_term_learning_goals', label: 'Set realistic short- and longer-term learning goals, define a path, and monitor progress' },
              { value: 'demonstrate_safe_behaviours', label: 'Demonstrate safe behaviours in a variety of environments' }
            ],
            initiate: [
              { value: 'recognize_the_intersection_of_personal_and_public_digital_identities', label: 'Recognize the intersection of their personal and public digital identities and the potential for both positive and negative consequences' },
              { value: 'question_self_and_others_about_the_role_of_technology', label: 'Question self and others about the role of technology in the changing workplace' }
            ],
            share: [
              { value: 'share_ideas_and_reflect_on_how_experiences_contribute', label: 'Share ideas and reflect on how experiences contribute to personal and collective growth (implied from the learning cycle)' }
            ]
          }
        }
      },
  "english_4": {
    "label": "English Language Arts (Grade 4)",
    "topics": [
      { "value": "comprehend_connect", "label": "Comprehend and Connect (Reading, Listening, Viewing)" },
      { "value": "create_communicate", "label": "Create and Communicate (Writing, Speaking, Representing)" }
    ],
    "competencies": {
      "core": [
        { "value": "comprehend_connect", "label": "Comprehend and Connect (reading, listening, viewing)" },
        { "value": "create_communicate", "label": "Create and Communicate (writing, speaking, representing)" }
      ],
      "sub": {
        "comprehend_connect": [
          {
            "value": "access_integrate_information",
            "label": "Access and integrate information and ideas from a variety of sources and prior knowledge to build understanding"
          },
          {
            "value": "use_variety_comprehension_strategies",
            "label": "Use a variety of comprehension strategies before, during, and after reading, listening, or viewing to deepen understanding of text"
          },
          {
            "value": "consider_purposes_audiences_perspectives",
            "label": "Consider different purposes, audiences, and perspectives in exploring texts (Grade 4–5)"
          },
          {
            "value": "apply_variety_thinking_skills",
            "label": "Apply a variety of thinking skills to gain meaning from texts (Grade 4–5)"
          },
          {
            "value": "identify_context_perspective_voice",
            "label": "Identify how differences in context, perspectives, and voice influence meaning in texts (Grade 4–5)"
          },
          {
            "value": "recognize_role_of_language_identity",
            "label": "Recognize the role of language in personal, social, and cultural identity"
          },
          {
            "value": "use_experience_connect_deepen",
            "label": "Use personal experience and knowledge to connect to text and deepen understanding of self, community, and world"
          },
          {
            "value": "respond_personal_creative",
            "label": "Respond to text in personal and creative ways (Grade 4–5)"
          },
          {
            "value": "recognize_literary_elements_devices",
            "label": "Recognize how literary elements, techniques, and devices enhance meaning in texts (Grade 4–5)"
          },
          {
            "value": "understand_role_organization",
            "label": "Show increasing understanding of the role of organization in meaning (Grade 4–5)"
          },
          {
            "value": "awareness_fp_oral_tradition",
            "label": "Demonstrate awareness of oral tradition in First Peoples cultures and the purposes of First Peoples texts (Grade 4–5)"
          },
          {
            "value": "identify_fp_story_land",
            "label": "Identify how story in First Peoples cultures connects people to land (Grade 4–5)"
          }
        ],

        "create_communicate": [
          {
            "value": "exchange_ideas_perspectives",
            "label": "Exchange ideas and perspectives to build shared understanding (K-5)"
          },
          {
            "value": "writing_design_processes",
            "label": "Use writing and design processes to plan, develop, and create texts for a variety of purposes and audiences (Grade 4–5)"
          },
          {
            "value": "use_language_creative_playful",
            "label": "Use language in creative and playful ways to develop style (Grade 4–5)"
          },
          {
            "value": "communicate_paragraphs_conventions",
            "label": "Communicate in sentences and paragraphs, applying conventions of Canadian spelling, grammar, and punctuation"
          },
          {
            "value": "develop_apply_word_knowledge",
            "label": "Develop and apply expanding word knowledge (Grade 3–5)"
          },
          {
            "value": "use_oral_storytelling_processes",
            "label": "Use oral storytelling processes (Grade 3–5)"
          },
          {
            "value": "transform_ideas_create_original_texts",
            "label": "Transform ideas and information to create original texts (Grade 4–9)"
          }
        ]
      }
    }
  }

,
 "math_4": {
    "label": "Mathematics (Grade 4)",
    "topics": [
      { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
      { "value": "understanding_solving", "label": "Understanding and Solving" },
      { "value": "communicating_representing", "label": "Communicating and Representing" },
      { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
    ],

    "competencies": {
      "core": [
        { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
        { "value": "understanding_solving", "label": "Understanding and Solving" },
        { "value": "communicating_representing", "label": "Communicating and Representing" },
        { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
      ],

      "sub": {
        "reasoning_analyzing": [
          {
            "value": "use_reasoning_make_connections_k5",
            "label": "Use reasoning to explore and make connections"
          },
          {
            "value": "estimate_reasonably_k5",
            "label": "Estimate reasonably"
          },
          {
            "value": "develop_mental_math_strategies_k5",
            "label": "Develop mental math strategies and abilities to make sense of quantities"
          },
          {
            "value": "use_technology_explore_math_k5",
            "label": "Use technology to explore mathematics"
          }
        ],

        "understanding_solving": [
          {
            "value": "model_mathematics_context_k5",
            "label": "Model mathematics in contextualized experiences"
          },
          {
            "value": "apply_understanding_play_inquiry_k5",
            "label": "Develop, demonstrate, and apply mathematical understanding through play, inquiry, and problem solving"
          },
          {
            "value": "visualize_explore_math_concepts_k5",
            "label": "Visualize to explore mathematical concepts"
          },
          {
            "value": "use_multiple_problem_solving_strategies_k5",
            "label": "Develop and use multiple strategies to engage in problem solving"
          },
          {
            "value": "connect_problem_solving_local_culture_k5",
            "label": "Engage in problem-solving experiences connected to place, story, cultural practices, and perspectives relevant to local First Peoples communities, the local community, and other cultures"
          }
        ],

        "communicating_representing": [
          {
            "value": "communicate_math_thinking_k5",
            "label": "Communicate mathematical thinking in many ways"
          },
          {
            "value": "use_math_vocabulary_k5",
            "label": "Use mathematical vocabulary and language to contribute to mathematical discussions"
          },
          {
            "value": "explain_justify_math_ideas_k5",
            "label": "Explain and justify mathematical ideas and decisions"
          },
          {
            "value": "represent_math_ideas_k5",
            "label": "Represent mathematical ideas in concrete, pictorial, and symbolic forms"
          }
        ],

        "connecting_reflecting": [
          {
            "value": "reflect_math_thinking_k5",
            "label": "Reflect on mathematical thinking"
          },
          {
            "value": "connect_math_concepts_k5",
            "label": "Connect mathematical concepts to each other and to other areas and personal interests"
          },
          {
            "value": "incorporate_first_peoples_perspectives_k5",
            "label": "Incorporate First Peoples worldviews and perspectives to make connections to mathematical concepts"
          }
        ]
      }
    }
  },
"phe_4": {
    "label": "Physical and Health Education (Grade 4)",
   "topics": [
      { "value": "physical_literacy", "label": "Physical Literacy" },
      { "value": "healthy_active_living", "label": "Healthy and Active Living" },
      { "value": "social_community_health", "label": "Social and Community Health" },
      { "value": "mental_well_being", "label": "Mental Well-Being" }
    ],

    "competencies": {
      "core": [
        { "value": "physical_literacy", "label": "Physical Literacy" },
        { "value": "healthy_active_living", "label": "Healthy and Active Living" },
        { "value": "social_community_health", "label": "Social and Community Health" },
        { "value": "mental_well_being", "label": "Mental Well-Being" }
      ],

      "sub": {
        "physical_literacy": [
          {
            "value": "develop_apply_movement_skills_4",
            "label": "Develop and apply movement skills (3–5)"
          },
          {
            "value": "apply_movement_concepts_strategies_4",
            "label": "Apply movement concepts and strategies (3–4)"
          },
          {
            "value": "apply_exertion_monitoring_4",
            "label": "Apply exertion monitoring (2–4)"
          },
          {
            "value": "safety_fair_play_leadership_4",
            "label": "Develop and demonstrate safety, fair play, and leadership (K–9)"
          },
          {
            "value": "identify_preferred_activities_4",
            "label": "Identify preferred physical activities (4–9)"
          }
        ],

        "healthy_active_living": [
          {
            "value": "opportunities_challenges_participation_4",
            "label": "Identify opportunities and challenges to participation (4–5)"
          },
          {
            "value": "healthy_eating_relationship_health_4",
            "label": "Explain the relationship of healthy eating to overall health"
          },
          {
            "value": "factors_influencing_healthy_choices_4",
            "label": "Identify and describe factors influencing healthy choices"
          },
          {
            "value": "health_messages_influence_4",
            "label": "Examine how health messages influence decisions"
          },
          {
            "value": "personal_healthy_living_strategies_4",
            "label": "Identify and apply personal healthy-living strategies"
          }
        ],

        "social_community_health": [
          {
            "value": "avoidance_assertiveness_strategies_4",
            "label": "Describe avoidance/assertiveness strategies (2–4)"
          },
          {
            "value": "discrimination_bullying_responses_4",
            "label": "Describe and assess responses to discrimination and bullying (4–7)"
          },
          {
            "value": "positive_relationships_strategies_4",
            "label": "Apply strategies for developing positive relationships (3–4)"
          },
          {
            "value": "promote_safe_caring_environment_4",
            "label": "Promote a safe and caring environment (4–5)"
          }
        ],

        "mental_well_being": [
          {
            "value": "assess_strategies_mental_well_being_4",
            "label": "Describe and assess strategies for mental well-being"
          },
          {
            "value": "manage_problems_mental_well_being_substance_use_4",
            "label": "Manage problems related to mental well-being and substance use"
          },
          {
            "value": "explore_puberty_changes_4",
            "label": "Explore changes during puberty (4–5)"
          },
          {
            "value": "factors_influencing_self_identity_4",
            "label": "Describe factors influencing self-identity"
          }
        ]
      }
    }
  },

  
      science_4: {
        label: "Science (Grade 4)",
        topics: [
          { value: "ecosystems", label: "Ecosystems" },
          { value: "forces_motion", label: "Forces and Motion" }
        ],
        competencies: {
          core: [
            { value: "questioning_predicting", label: "Questioning and Predicting" },
            { value: "planning_conducting", label: "Planning and Conducting" },
            { value: "processing_analyzing", label: "Processing and Analyzing Data and Information" },
            { value: "evaluating", label: "Evaluating" },
            { value: "applying_innovating", label: "Applying and Innovating" },
            { value: "communicating", label: "Communicating" }
          ],
          sub: {
            questioning_predicting: [
              { value: "curiosity_natural_world", label: "Demonstrate curiosity about the natural world" },
              { value: "observe_familiar", label: "Observe objects and events in familiar contexts" },
              { value: "identify_investigable_questions", label: "Identify questions about familiar objects and events that can be investigated scientifically" },
              { value: "predictions_prior_knowledge", label: "Make predictions based on prior knowledge" }
            ],

            planning_conducting: [
              { value: "suggest_plans", label: "Suggest ways to plan and conduct an inquiry to find answers" },
              { value: "ethical_responsibilities", label: "Consider ethical responsibilities when conducting experiments" },
              { value: "use_tools_safely", label: "Safely use appropriate tools to make observations and measurements, using digital technology where appropriate" }
            ],

            processing_analyzing: [
              { value: "observe_living_nonliving", label: "Make observations about living and non-living things in the local environment" },
              { value: "collect_simple_data", label: "Collect simple data" },
              { value: "interpret_environment", label: "Experience and interpret the local environment" },
              { value: "first_peoples_perspectives", label: "Identify First Peoples perspectives and knowledge as sources of information" },
              { value: "sort_classify_information", label: "Sort and classify data and information using drawings or provided tables" },
              { value: "represent_data", label: "Use tables, simple bar graphs, or other formats to represent data and show patterns" },
              { value: "compare_results", label: "Compare results with predictions" },
              { value: "make_simple_inferences", label: "Make simple inferences based on results and prior knowledge" }
            ],

            evaluating: [
              { value: "fair_test_reflection", label: "Reflect on whether an investigation was a fair test" },
              { value: "appreciate_evidence", label: "Demonstrate an understanding and appreciation of evidence" },
              { value: "environmental_implications", label: "Identify some simple environmental implications of actions" }
            ],

            applying_innovating: [
              { value: "care_self_others", label: "Contribute to care for self, others, school, and neighbourhood through personal or collaborative approaches" },
              { value: "cooperative_design", label: "Co-operatively design projects" },
              { value: "apply_learning", label: "Transfer and apply learning to new situations" },
              { value: "generate_new_ideas", label: "Generate and introduce new or refined ideas when problem solving" }
            ],

            communicating: [
              { value: "represent_communicate", label: "Represent and communicate ideas and findings in a variety of ways, such as diagrams and simple reports, using digital technologies as appropriate" },
              { value: "express_reflect_place", label: "Express and reflect on personal or shared experiences of place" }
            ]
          }
        }
      }
      ,
    
     
  "social_studies_4": {
    "label": "Social Studies (Grade 4)",
     "topics": [
      { "value": "inquiry", "label": "Inquiry" },
      { "value": "significance", "label": "Significance" },
      { "value": "evidence", "label": "Evidence" },
      { "value": "continuity_change", "label": "Continuity and Change" },
      { "value": "cause_consequence", "label": "Cause and Consequence" },
      { "value": "perspective", "label": "Perspective" },
      { "value": "ethical_judgement", "label": "Ethical Judgement" }
    ],

    "competencies": {
      "core": [
        { "value": "inquiry", "label": "Inquiry" },
        { "value": "significance", "label": "Significance" },
        { "value": "evidence", "label": "Evidence" },
        { "value": "continuity_change", "label": "Continuity and Change" },
        { "value": "cause_consequence", "label": "Cause and Consequence" },
        { "value": "perspective", "label": "Perspective" },
        { "value": "ethical_judgement", "label": "Ethical Judgement" }
      ],

      "sub": {
        "inquiry": [
          {
            "value": "inquiry_process_ss4",
            "label": "Use Social Studies inquiry processes and skills to ask questions; gather, interpret, and analyze ideas; and communicate findings and decisions"
          }
        ],

        "significance": [
          {
            "value": "construct_arguments_significance_ss4",
            "label": "Construct arguments defending the significance of individuals/groups, places, events, or developments"
          }
        ],

        "evidence": [
          {
            "value": "ask_corroborate_conclude_ss4",
            "label": "Ask questions, corroborate inferences, and draw conclusions about the content and origins of different sources"
          }
        ],

        "continuity_change": [
          {
            "value": "sequence_determine_continuity_change_ss4",
            "label": "Sequence objects, images, or events, and determine continuities and changes between different time periods or places"
          }
        ],

        "cause_consequence": [
          {
            "value": "differentiate_consequences_ss4",
            "label": "Differentiate between intended and unintended consequences of events, decisions, or developments, and speculate about alternative outcomes"
          }
        ],

        "perspective": [
          {
            "value": "construct_narratives_perspectives_ss4",
            "label": "Construct narratives that capture the attitudes, values, and worldviews commonly held by people at different times or places"
          }
        ],

        "ethical_judgement": [
          {
            "value": "make_ethical_judgments_ss4",
            "label": "Make ethical judgments about events, decisions, or actions that consider the conditions of a particular time and place"
          }
        ]
      }
    }
  },
  
  
  





    }
  };
export default grade_4; 